import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../config/api';
import LoadingScreen from '../components/LoadingScreen';
import { useLang } from '../context/LanguageContext';
import '../styles/ProductsPage.css';
import { Helmet } from 'react-helmet-async';

const ProductsPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { nl } = useLang();
  const L = (obj, field) => (nl && obj?.[field + '_nl']) || obj?.[field] || '';
  const [serviceData, setServiceData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [seoData, setSeoData] = useState(null);
  const [expandedItems, setExpandedItems] = useState({});

  const toggleItem = (sectionIdx, itemIdx) => {
    const key = `${sectionIdx}-${itemIdx}`;
    setExpandedItems(prev => ({ ...prev, [key]: !prev[key] }));
  };
  
  useEffect(() => {
  fetch(`${API_BASE_URL}/api/seo/${slug}`)
    .then(res => res.json())
    .then(data => {
      if (data.success) {
        setSeoData(data.data);
      }
    })
    .catch(err => console.error("SEO fetch error:", err));
}, [slug]);
// console.log("Slug: ", slug);

// console.log("This is : ", seoData);

  

  useEffect(() => {
    if (!document.querySelector('link[href*="style.css"]')) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = '/css/style.css';
      document.head.appendChild(link);
    }

    const fetchService = async () => {
      if (!slug) {
        setLoading(false);
        return;
      }
      
      try {
        const response = await axios.get(`${API_BASE_URL}/api/services/${slug}`);
        console.log('Full API Response:', response.data);
        console.log('Service data structure:', JSON.stringify(response.data.data, null, 2));
        setServiceData(response.data.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching service:', error);
        setLoading(false);
      }
    };

    fetchService();
  }, [slug]);

  if (loading) return <LoadingScreen />;

  if (!serviceData) {
    return <div style={{ padding: '100px 20px', textAlign: 'center' }}>Product not found</div>;
  }

  console.log('service data true onw',serviceData)
   
  return (
    <>
      <Helmet>
        <title>{seoData?.title || 'Aurelia Technology'}</title>
        {seoData?.description && <meta name="description" content={seoData.description} />}
        {seoData?.keywords && <meta name="keywords" content={seoData.keywords} />}
        {seoData?.canonicalUrl && <link rel="canonical" href={seoData.canonicalUrl} />}
        <meta property="og:title" content={seoData?.ogTitle || seoData?.title || 'Aurelia Technology'} />
        <meta property="og:description" content={seoData?.ogDescription || seoData?.description || ''} />
        {seoData?.ogImage && <meta property="og:image" content={seoData.ogImage} />}
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoData?.twitterTitle || seoData?.ogTitle || seoData?.title || 'Aurelia Technology'} />
        <meta name="twitter:description" content={seoData?.twitterDescription || seoData?.ogDescription || seoData?.description || ''} />
        {(seoData?.twitterImage || seoData?.ogImage) && <meta name="twitter:image" content={seoData.twitterImage || seoData.ogImage} />}
      </Helmet>
      {/* Hero Section */}
      {serviceData.heroSection && serviceData.heroSection.title && (
        <section className="contact-banner" style={{
          backgroundImage: serviceData.image ? `url(${serviceData.image})` : 'none'
        }}>
          <div className="banner-overlay"></div>
          <div className="banner-content">
            <div className="banner-left">
              <h1>{L(serviceData.heroSection, 'title')}</h1>
              <p>{L(serviceData.heroSection, 'subtitle')}</p>
            </div>
          </div>
        </section>
      )}

      {/* Default Banner if no hero section */}
      {(!serviceData.heroSection || !serviceData.heroSection.title) && (
        <section className="contact-banner">
          <div className="banner-overlay"></div>
          <div className="banner-content">
            <div className="banner-left">
              <h1>{L(serviceData, 'title')}</h1>
              <p>{L(serviceData, 'excerpt')}</p>
            </div>
          </div>
        </section>
      )}

      {/* Main Content */}
      <section className="products-specializations">
        <div className="container">
          <div className="products-section-header">
            <h2>{L(serviceData, 'title')}</h2>
            <p>{L(serviceData, 'description') || L(serviceData, 'excerpt')}</p>
            <div className="products-section-divider">
              <div className="products-divider-line"></div>
              <div className="products-divider-dots">
                <span className="products-dot"></span>
                <span className="products-dot"></span>
                <span className="products-dot"></span>
                <span className="products-dot"></span>
                <span className="products-dot"></span>
              </div>
            </div>
          </div>

          {/* Technologies */}
          {serviceData.technologies && serviceData.technologies.length > 0 && (
            <div className="products-spec-tags" style={{ textAlign: 'center', marginBottom: '40px' }}>
              {serviceData.technologies.map((tech, idx) => (
                <span key={idx} className="products-spec-tag">{tech}</span>
              ))}
            </div>
          )}

          {/* Sections as Cards */}
          {serviceData.sections && serviceData.sections.length > 0 && (
            <div className="products-specializations-list">
              {serviceData.sections
                .sort((a, b) => (a.order || 0) - (b.order || 0))
                .map((section, idx) => (
                <div key={idx} className="products-specialization-item">
                  {section.image && (
                    <div className="products-spec-image" style={{ position: 'relative' }}>
                      <img src={section.image} alt={L(section, 'title')} />
                      <div className="products-spec-category products-spec-category-overlay" style={{ 
                        position: 'absolute', 
                        top: '10px', 
                        right: '10px', 
                        padding: '4px 8px',
                        backgroundColor: 'rgba(0,0,0,0.7)',
                        color: 'white',
                        borderRadius: '4px',
                        fontSize: '12px',
                        display: 'none'
                      }}>{section.sectionType || section.type || 'Section'}</div>
                    </div>
                  )}
                  <div className="products-spec-content">
                    <div className="products-spec-header">
                      <h3>{L(section, 'title')}</h3>
                      <div className="products-spec-category products-spec-category-normal">{section.sectionType || section.type || 'Section'}</div>
                    </div>
                    {(nl ? section.subtitle_nl : null) || section.subtitle ? <p style={{ marginBottom: '20px', color: '#666', fontSize: '0.85rem', lineHeight: '1.4' }}>{L(section, 'subtitle')}</p> : null}
                    
                    {/* Section Items */}
                    {section.items && section.items.length > 0 && (
                      <div className="products-spec-sections">
                        <h4>Key Points</h4>
                        <div className="products-sections-list">
                          {section.items.map((item, itemIdx) => {
                            const key = `${idx}-${itemIdx}`;
                            const isExpanded = expandedItems[key];
                            
                            return (
                            <div key={itemIdx} className="products-section-item">
                              <div className='products-section-title' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }} onClick={() => toggleItem(idx, itemIdx)}>
                                <h5>{L(item, 'title')}</h5>
                                <button style={{ 
                                  background: '#B28744', 
                                  color: 'white', 
                                  border: 'none', 
                                  borderRadius: '50%', 
                                  width: '24px', 
                                  height: '24px', 
                                  cursor: 'pointer',
                                  fontSize: '16px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center'
                                }}>
                                  {isExpanded ? '−' : '+'}
                                </button>
                              </div>
                              {isExpanded && (
                                <div className="products-section-description" style={{ marginTop: '8px' }}>
                                  <p style={{ 
                                    color: '#666', 
                                    fontSize: '0.85rem', 
                                    lineHeight: '1.4'
                                  }}>{(L(item, 'description'))?.split('.')[0] + '.' || 'No description available'}</p>
                                </div>
                              )}
                            </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                    
                    {/* Section Stats */}
                    {section.stats && section.stats.length > 0 && (
                      <div className="products-spec-stats">
                        {section.stats.map((stat, statIdx) => (
                          <div key={statIdx} className="products-spec-stat">
                            <div className="products-stat-number">{stat.number}{stat.suffix}</div>
                            <span>{L(stat, 'label')}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Key Features as Cards */}
          {serviceData.keyFeatures && serviceData.keyFeatures.length > 0 && (
            <div className="products-specializations-list">
              {serviceData.keyFeatures.map((feature, idx) => (
                <div key={idx} className="products-specialization-item">
                  <div className="products-spec-content">
                    <div className="products-spec-category">Feature</div>
                    <div className="products-spec-header">
                      <h3>{L(feature, 'title')}</h3>
                      <p>{L(feature, 'description')}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

     
    </>
  );
};



export default ProductsPage;